var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shirt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloth",
    "data-name": "cloth"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#000000",
    points: "53,15 61,51 54,53 47,30 46,54 19,54 17,32 10,52 3,51 11,15 24,11 24,6 40,6 40,11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#000000",
    d: "M11,19.3L5.5,45.9c0,0,0,0.1,0,0.1c0,1.1,1.1,2,2.4,2c1.1,0,2-0.6,2.3-1.4L16.1,24l3.9,0.5V48c0,2.2,3.6,4,8,4             c0.1,0,0.2,0,0.3,0C37,51.8,44,44.7,44,36h1v21h-5v3H16V40.3L11.9,56L0,53l7-34.5c0.8-3.8,3.6-6.8,7.4-7.7L22,8.9L24,4l8,8l8-8             l2,5l-4,9l-6-6l-6,6l-2.4-5.3l-8.2,2.1C13.1,15.3,11.4,17.1,11,19.3z M51.5,38H51l3,15l7-2l-3-15h-1.5c0.1,0.3,0.1,0.6,0.1,1             c0,1.7-1.2,3-2.6,3C52.9,40,51.9,39.2,51.5,38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#000000",
    d: "M40,4l-4,4h-8l-4-4H40zM53,19.3l6.3,30.8l-4.4,1.1l-7-27.2L44,24.5V56h-8v4h12V40.3L52.1,56L64,53l-7-34.5             c-0.8-3.8-3.6-6.8-7.4-7.7L42,8.9L42,9l-1.6,3.7l8.3,2.1C50.9,15.3,52.6,17.1,53,19.3zM32,20c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2             c1.1,0,2-0.9,2-2C34,20.9,33.1,20,32,20z M32,32c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2C34,32.9,33.1,32,32,32z             M32,48c1.1,0,2-0.9,2-2s-0.9-2-2-2c-1.1,0-2,0.9-2,2S30.9,48,32,48z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloth);
export default __webpack_public_path__ + "static/media/cloth.99df32e4c7ab0ca4608b6589f4d6b672.svg";
export { ForwardRef as ReactComponent };